import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { AddBanner, GetBanner, EditBanner, UploadBannerPic } from '../../fetchs';
import DatePicker from 'react-datepicker2';

import './banner.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Banner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gregorianShowFrom: null,
      gregorianShowTo: null,
      picUrl: null,
      showOrder: 0,
      showLocation: 0,
      loading: false,
      saving: false,
      uploadPic: false
    }
  }

  componentDidMount() {
    const bannerId = this.props.match.params.bannerId;
    if (bannerId) {
      this.loadBanner(bannerId);
    }
  }

  loadBanner = (bannerId) => {
    this.setState({ loading: true });
    GetBanner(bannerId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          bannerId: responseJson.bannerId,
          gregorianShowFrom: responseJson.gregorianShowFrom,
          gregorianShowTo: responseJson.gregorianShowTo,
          showOrder: responseJson.showOrder,
          showLocation: responseJson.showLocation,
          picUrl: responseJson.picUrl
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    if (this.props.match.params.articleId) {
      EditBanner(this.state.articleId, {
        gregorianShowFrom: this.state.gregorianShowFrom,
        gregorianShowTo: this.state.gregorianShowTo,
        showOrder: this.state.showOrder,
        showLocation: this.state.showLocation,
        picUrl: this.state.picUrl
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/banners');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddBanner({
        gregorianShowFrom: this.state.gregorianShowFrom,
        gregorianShowTo: this.state.gregorianShowTo,
        showOrder: this.state.showOrder,
        showLocation: this.state.showLocation,
        picUrl: this.state.picUrl
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/banners');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleSelectFile = event => {
    this.setState({ uploadPic: true });
    UploadBannerPic(this.state.bannerId, event.target.files[0])
      .then(response => {
        this.setState({ uploadPic: false });
        return response.json();
      }).then(responseJson => {
        this.setState({
          picUrl: responseJson.path
        })
      }).catch(error => {
        console.error(error);
      })
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن بنر جدید
            </Typography>
            <Grid container>
              <Grid item md={7}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <div className="MuiFormControl-root MuiTextField-root MuiFormControl-marginNormal MuiFormControl-fullWidth">
                          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                            data-shrink="true" htmlFor="standard-from-date">از</label>
                          <DatePicker
                            id="standard-from-date"
                            onChange={value => this.setState({ gregorianShowFrom: value })}
                            value={this.state.gregorianShowFrom}
                            isGregorian={false}
                            fullWidth
                            className="textField"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className="MuiFormControl-root MuiTextField-root MuiFormControl-marginNormal MuiFormControl-fullWidth">
                          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                            data-shrink="true" htmlFor="standard-to-date">تا</label>
                          <DatePicker
                            id="standard-to-date"
                            onChange={value => this.setState({ gregorianShowTo: value })}
                            value={this.state.gregorianShowTo}
                            isGregorian={false}
                            fullWidth
                            className="textField"
                          />
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-show-order"
                          label="ترتیب نمایش"
                          required
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.showOrder}
                          onChange={this.handleChange('showOrder')}
                          margin="normal"
                        />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-select-article-category"
                          select
                          label="دسته بندی"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.articleCategoryId}
                          onChange={this.handleChange('articleCategoryId')}
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                            },
                          }}
                          margin="normal"
                        >
                          {this.state.articleCategories.map(option => (
                            <MenuItem key={option.articleCategoryId} value={option.articleCategoryId}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-show-location"
                          label="مکان نمایش"
                          type="number"
                          fullWidth
                          className={classes.textField}
                          value={this.state.showLocation}
                          onChange={this.handleChange('showLocation')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={this.state.loading}
                          onClick={this.handleSave}>ذخیره</Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
              <Grid item md={5}>
                <div>
                  <input
                    accept="image/*"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={this.handleSelectFile}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      fullWidth
                      variant="contained"
                      component="span"
                      className={classes.button}
                    >
                      ارسال عکس
                      </Button>
                    {this.state.uploadPic && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </label>
                </div>
                <div>
                  <div className="picParent">
                    <img src={`http://localhost:5000/${this.state.url}`} className="picture" alt={this.state.text} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Banner.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Banner));
